export enum AnalyticsScreenType {
  Web = 'web',
  Native = 'native',
  NativeInvest = 'native_invest',
}

export enum AnalyticsLoadPageType {
  Landing = 'landing',
  BringAFriend = 'bring_a_friend',
}

export enum AnalyticsClickToPlayType {
  Landing = 'landing',
  BringAFriend = 'bring_a_friend',
}

export enum AnalyticsAuthEventType {
  AuthUserValid = 'auth_user_valid',
  AuthError = 'auth_',
}

export enum AnalyticsClaimRewardDailyDayType {
  FirstDay = 'first_day',
  SecondDay = 'second_day',
  ThirdDay = 'third_day',
  FourthDay = 'fourth_day',
}

export enum AnalyticsClaimRewardDailyRewardType {
  InGameReward = 'in_game_reward',
  ProductReward = 'product_reward',
}

export enum AnalyticsOnboardingUserType {
  WithReward = 'with_reward',
  WithoutReward = 'without_reward',
}

export enum AnalyticsStartOnboardingType {
  Continue = 'continue',
  Skip = 'skip',
}

export enum AnalyticsClickerMenuButtonType {
  Gifts = 'gifts',
  Settings = 'settings',
  League = 'league',
  Upgrades = 'upgrades',
  Tasks = 'tasks',
  Minigame = 'minigame',
  Energy = 'energy',
}

export enum AnalyticsCipherDailyGameType {
  QuestionMark = 'question_mark',
  PulseHint = 'pulse_hint',
  PulseCopyLink = 'pulse_copy_link',
  Return = 'return',
}

export enum AnalyticsChangeGiftsTabType {
  AllGifts = 'all_gifts',
  UsersGifts = 'users_gifts',
}

export enum AnalyticsGiftType {
  Gift = 'gift_',
}

export enum AnalyticsFirstImprovementType {
  Upgrade = 'upgrade',
  Buy = 'buy',
}

export enum AnalyticsTaskType {
  Task = 'task_',
}

export enum AnalyticsTaskButtonsType {
  GoTo = 'go_to',
  CopyLink = 'copy_link',
  GetReward = 'get_reward',
  FriendInvitation = 'friend_invitation',
}

export enum AnalyticsLeaderboardButtonsType {
  Info = 'info',
  Refresh = 'refresh',
}

export enum AnalyticsRecalculationLeaguesType {
  ScreenShown = 'screen_shown',
  Refresh = 'refresh',
}

export enum AnalyticsSettingsSwitchType {
  Notifications = 'notifications',
  Music = 'music',
  Sounds = 'sounds',
  SpeedUp = 'speed_up',
}

export enum AnalyticsSettingsSwitchValueType {
  On = 'on',
  Off = 'off',
}

export enum AnalyticsFaqQuestionType {
  Block = 'block',
  Button = 'button',
}

export enum AnalyticsFaqQuestionButtonType {
  OpenInApp = 'open_in_app',
}

export enum AnalyticsNewInvestGameButtonType {
  EndGame = 'end_game',
  Settings = 'settings',
}

export const analyticsFooterLinkType = 'button';
